import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Typography, Paper, Grid, Alert, DialogContentText, Box } from '@mui/material';

const CapacityWarningDialog = ({
  open,
  onClose,
  onConfirm,
  event,
  summary,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Kontenjan Uyarısı</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Alert severity="warning">
            Bu katılımcıyı "Sırada Bekliyor" durumundan "Beklemede" durumuna çekmek üzeresiniz. Lütfen kontenjan durumunu kontrol edin.
          </Alert>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Stack spacing={1.5}>
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Kontenjan Bilgileri</Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="body2" color="text.secondary">Toplam Kapasite</Typography>
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>{typeof event?.capacity === 'number' ? event.capacity : 'Sınırsız'}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" color="text.secondary">Kayıtlı Katılımcı</Typography>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: 'primary.main' }}>
                    {typeof event?.registeredCount === 'number' ? event.registeredCount : 0}
                  </Typography>
                </Grid>
                {typeof event?.capacity === 'number' && (
                  <>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="text.secondary">Boş Kontenjan</Typography>
                      <Typography variant="h6" sx={{ fontWeight: 700, color: (event.capacity - (event.registeredCount || 0)) > 0 ? 'success.main' : 'error.main' }}>
                        {Math.max(0, event.capacity - (event.registeredCount || 0))}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="text.secondary">Doluluk Oranı</Typography>
                      <Typography variant="h6" sx={{ fontWeight: 700 }}>
                        {event.capacity > 0 ? Number(((event.registeredCount || 0) / event.capacity) * 100).toFixed(1) : 0}%
                      </Typography>
                    </Grid>
                  </>
                )}
              </Grid>
              {summary && (
                <Box sx={{ mt: 1, pt: 2, borderTop: '1px solid', borderColor: 'divider' }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>Katılım Durumları</Typography>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="text.secondary">Beklemede</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>{summary.pendingCount ?? 0}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="text.secondary">Katıldı</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600, color: 'success.main' }}>{summary.attendedCount ?? 0}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="text.secondary">Gelmedi</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600, color: 'warning.main' }}>{summary.absentCount ?? 0}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="text.secondary">İptal</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600, color: 'error.main' }}>{summary.cancelledCount ?? 0}</Typography>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Stack>
          </Paper>
          <DialogContentText>
            Bu işlemi onaylıyor musunuz? Katılımcı "Beklemede" durumuna geçecek ve kontenjan durumu güncellenecektir.
          </DialogContentText>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>İptal</Button>
        <Button variant="contained" color="primary" onClick={onConfirm}>
          Onayla ve Devam Et
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CapacityWarningDialog;

